import React from "react";

const ElectronicEquipmentComponentsIcon = ({
  color = "#5D5D5D",
  width = "23",
  height = "23",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4583 15.8112C13.4003 17.3816 14.7349 18.6796 16.331 19.5774L17.7292 20.3633V20.6029H5.27083V20.3633L6.66904 19.5774C8.26505 18.6796 9.59972 17.3816 10.5417 15.8112M1.4375 12.9362H21.5625M21.5625 2.39453H1.4375V15.8112H21.5625V2.39453Z"
        stroke={color}
      />
    </svg>
  );
};

export default ElectronicEquipmentComponentsIcon;
